import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';

const KEY = 'mes-theme';
const MODES = ['system', 'dark', 'light'];

/* Тема: тёмная в цехе, светлая в кабинете и на проекторе.
   Режим system следует за настройкой ОС — тогда планшет сам темнеет
   вечером, если это настроено на устройстве. */
export const useThemeStore = defineStore('theme', () => {
  const read = () => {
    try {
      const v = localStorage.getItem(KEY);
      return MODES.includes(v) ? v : 'dark';
    } catch { return 'dark'; }
  };

  const mode = ref(read());
  const systemDark = ref(true);

  const media = window.matchMedia?.('(prefers-color-scheme: dark)');
  if (media) {
    systemDark.value = media.matches;
    media.addEventListener('change', (e) => { systemDark.value = e.matches; });
  }

  const effective = computed(() => (mode.value === 'system' ? (systemDark.value ? 'dark' : 'light') : mode.value));

  /* На <html> всегда попадает вычисленная тема, а не режим: тогда в токенах
     светлая палитра описана один раз, без дублирования в медиазапросе. */
  const apply = () => {
    document.documentElement.setAttribute('data-theme', effective.value);
  };

  watch(mode, (v) => {
    try { localStorage.setItem(KEY, v); } catch { /* приватный режим */ }
    apply();
  }, { immediate: true });

  // В режиме system тема должна меняться вслед за настройкой ОС на ходу
  watch(systemDark, () => { if (mode.value === 'system') apply(); });

  const set = (v) => { if (MODES.includes(v)) mode.value = v; };
  // Кнопка в шапке переключает по кругу: тёмная → светлая → системная
  const cycle = () => set(MODES[(MODES.indexOf(mode.value) + 1) % MODES.length]);

  return { mode, effective, systemDark, set, cycle, MODES };
});
